import React from "react";
import Alert from "../../../components/Alert";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import Tag from "../../../components/Tag";
import {
  actionGetEquipamentos,
  actionGetUnidadeDeMedida,
} from "../../../features/equipamentos/slices";
import { actionGetGrupoMonitoramento } from "../../../features/grupos-de-monitoramento/slices";
import { actionGetModuloByCentral } from "../../../features/modulo/slices";
import {
  actionDeleteConfigPtMonAnalogico,
  actionResetDeleteConfigPtMonAnalogico,
} from "../../../features/monitoramento/analogico/delete-monitoramento/slices";
import {
  actionGetConfigPtMonAnalogico,
  actionResetGetConfigPtMonAnalogico,
} from "../../../features/monitoramento/analogico/get-monitoramento/slices";
import {
  actionPostConfigPtMonAnalogico,
  actionResetStateConfigPtMonAnalogico,
} from "../../../features/monitoramento/analogico/slices";
import {
  actionResetStateUpdadePtMonAnalogico,
  actionUpdateConfigPtMonAnalogico,
} from "../../../features/monitoramento/analogico/update-monitoramento/slices";
import {
  actionDeleteConfigPtMonDigital,
  actionResetDeleteConfigPtMonDigital,
} from "../../../features/monitoramento/digital/delete-monitoramento/slices";
import { actionResetGetConfigPtMonDigital } from "../../../features/monitoramento/digital/get-monitoramento/slices";
import {
  actionPostConfigPtMonDigital,
  actionResetStateConfigPtMonDigital,
} from "../../../features/monitoramento/digital/slices";
import {
  actionResetStateUpdadePtMonDigital,
  actionUpdateConfigPtMonDigital,
} from "../../../features/monitoramento/digital/update-monitoramento/slices";
import {
  actionDeleteConfigPtMonMedidor,
  actionResetDeleteConfigPtMonMedidor,
} from "../../../features/monitoramento/medidores/delete-monitoramento/slices";
import { actionResetGetConfigPtMonMedidor } from "../../../features/monitoramento/medidores/get-monitoramento/slices";
import {
  actionPostConfigPtMonMedidor,
  actionResetStateConfigPtMonMedidor,
} from "../../../features/monitoramento/medidores/slices";
import {
  actionResetStateUpdadePtMonMedidor,
  actionUpdateConfigPtMonMedidor,
} from "../../../features/monitoramento/medidores/update-monitoramento/slices";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import FormMonAnalogico from "./FormMonAnalogico";
import FormMonDigital from "./FormMonDigital";
import FormMonMedidor from "./FormMonMedidor";
import "./styles.scss";
import { postConfigPtMonAnalogico } from "../../../features/monitoramento/analogico/services";

const FeedbackRegisterPontoMonitoria = () => {
  const {
    configPtMonDigital,
    configPtMonAnalogico,
    configPtMonMedidor,
    updateConfigPtMonAnalogico,
    updateConfigPtMonDigital,
    updateConfigPtMonMedidor,
  } = useAppSelector((state) => state);

  if (
    configPtMonDigital.status === "success" ||
    configPtMonAnalogico.status === "success" ||
    configPtMonMedidor.status === "success"
  ) {
    return (
      <Alert type="success">
        <p>
          Configuração <strong>realizada</strong> com sucesso!
        </p>
      </Alert>
    );
  }

  if (configPtMonDigital.status === "error") {
    return (
      <Alert type="error">
        {configPtMonDigital.msgError
          ? configPtMonDigital.msgError
          : "Configuração não realizada, tente novamente!"}
      </Alert>
    );
  }

  if (configPtMonAnalogico.status === "error") {
    return (
      <Alert type="error">
        {configPtMonAnalogico.msgError
          ? configPtMonAnalogico.msgError
          : "Configuração não realizada, tente novamente!"}
      </Alert>
    );
  }

  if (configPtMonMedidor.status === "error") {
    return (
      <Alert type="error">
        {configPtMonMedidor.msgError
          ? configPtMonMedidor.msgError
          : "Configuração não realizada, tente novamente!"}
      </Alert>
    );
  }

  if (
    updateConfigPtMonDigital.status === "success" ||
    updateConfigPtMonAnalogico.status === "success" ||
    updateConfigPtMonMedidor.status === "success"
  ) {
    return (
      <Alert type="success">
        <p>
          Configuração <strong>atualizada</strong> com sucesso!
        </p>
      </Alert>
    );
  }

  if (updateConfigPtMonDigital.status === "error") {
    return (
      <Alert type="error">
        {updateConfigPtMonDigital.msgError
          ? updateConfigPtMonDigital.msgError
          : "Configuração não realizada, tente novamente!"}
      </Alert>
    );
  }

  if (updateConfigPtMonAnalogico.status === "error") {
    return (
      <Alert type="error">
        {updateConfigPtMonAnalogico.msgError
          ? updateConfigPtMonAnalogico.msgError
          : "Configuração não realizada, tente novamente!"}
      </Alert>
    );
  }

  if (updateConfigPtMonMedidor.status === "error") {
    return (
      <Alert type="error">
        {updateConfigPtMonMedidor.msgError
          ? updateConfigPtMonMedidor.msgError
          : "Configuração não realizada, tente novamente!"}
      </Alert>
    );
  }
  return null;
};

const HeaderModal = () => {
  const { entrada, modulo } = useAppSelector(
    (state) => state.modulosByCentral.entradaSelected,
  );

  let tipoEntrada: string;

  switch (entrada.tipo) {
    case "D":
      tipoEntrada = "Monitoramento Digital";
      break;
    case "A":
      tipoEntrada = "Monitoramento Analógico";
      break;
    case "R":
      tipoEntrada = "Medidores";
      break;
    default:
      tipoEntrada = "Ponto de Monitoramento";
      break;
  }

  return (
    <div className="container-fluid">
      <div className="infos-modulo">
        <div>
          <h2 className="heading heading--md color-primary">
            Configurar ponto de monitoramento
          </h2>
          <p className="paragraph paragraph--md color-secondary">
            {tipoEntrada}
          </p>
        </div>
        <div>
          <div className="infos-modulo__tags">
            <Tag inline size="sm">
              Central: {modulo.idCentral}
            </Tag>
            <Tag inline size="sm">
              Modulo: {modulo.adrModulo}
            </Tag>
            <Tag inline size="sm">
              Entrada: {entrada.id}
            </Tag>
          </div>
        </div>
      </div>
    </div>
  );
};

const ActionsModal = ({
  callbackCancel,
  callbackConfirm,
  callbackDeleteConfig,
  loading,
}) => {
  const [deleteAction, setDeleteAction] = React.useState(false);

  const handlerDelete = () => setDeleteAction(!deleteAction);

  if (deleteAction) {
    return (
      <div className="actions">
        <Button size="sm" variant="secondary" onClick={handlerDelete}>
          cancelar exclusão
        </Button>
        <Button
          size="sm"
          variant="danger"
          onClick={callbackDeleteConfig}
          loading={loading}
        >
          confirmar a exclusão do ponto
        </Button>
      </div>
    );
  }

  return (
    <div className="actions">
      {callbackDeleteConfig && (
        <Button size="sm" variant="danger" onClick={handlerDelete}>
          Excluir configurações
        </Button>
      )}
      <Button size="sm" variant="secondary" onClick={callbackCancel}>
        Cancelar
      </Button>
      <Button
        size="sm"
        variant="primary"
        onClick={callbackConfirm}
        loading={loading}
      >
        Confirmar
      </Button>
    </div>
  );
};

const RegisterPontoMonitora = ({ close }: any) => {
  const dispatch = useAppDispatch();
  const {
    getPtMonDigital,
    getPtMonAnalogico,
    getPtMonMedidor,
    configPtMonAnalogico,
    configPtMonDigital,
    configPtMonMedidor,
    updateConfigPtMonAnalogico,
    updateConfigPtMonDigital,
    updateConfigPtMonMedidor,
    deletePtMonAnalogico,
    deletePtMonDigital,
    deletePtMonMedidor,
    centraisByLoja: { centralSelected },
    modulosByCentral: {
      entradaSelected: { entrada },
    },
  } = useAppSelector((state) => state);

  const tipoMon = entrada.tipo;

  const loading =
    configPtMonAnalogico.status === "loading" ||
    configPtMonDigital.status === "loading" ||
    configPtMonMedidor.status === "loading" ||
    updateConfigPtMonAnalogico.status === "loading" ||
    updateConfigPtMonDigital.status === "loading" ||
    updateConfigPtMonMedidor.status === "loading";

  const [state, setState] = React.useState({
    monDigital: {},
    monAnalogico: {},
    monMedidor: {},
  } as any);

  const sendConfiguration = () => {
    console.log("sendConfiguration", tipoMon, state);
    console.log("configPtMonAnalogico", configPtMonAnalogico);
    console.log("configPtMonDigital", configPtMonDigital);
    console.log("updateConfigPtMonAnalogico", updateConfigPtMonAnalogico);

    if (tipoMon === "A") {
      if (entrada.ocupada) {
        dispatch(actionUpdateConfigPtMonAnalogico(state.monAnalogico));
        setTimeout(() => {
          if (updateConfigPtMonAnalogico.status === "success") {
            close();
          }
        }, 2000);
      } else {
        dispatch(actionPostConfigPtMonAnalogico(state.monAnalogico));
        setTimeout(() => {
          if (configPtMonAnalogico.status === "success") {
            close();
          }
        }, 2000);
      }
    } else if (tipoMon === "D") {
      const pad = (val) => {
        const clean = String(val || "").trim();
        if (!clean || clean === "undefined") return "00";
        return clean.padStart(2, "0");
      };

      let finalNV2 = "00:00:00";

      if (
        state.monDigital.hrMsgEscaladaNV2 ||
        state.monDigital.minMsgEscaladaNV2
      ) {
        finalNV2 = `${pad(state.monDigital.hrMsgEscaladaNV2)}:${pad(state.monDigital.minMsgEscaladaNV2)}:00`;
      } else if (state.monDigital.timeMsgEscaladaNV2) {
        const partes = state.monDigital.timeMsgEscaladaNV2.split(":");
        finalNV2 = `${pad(partes[0])}:${pad(partes[1])}:00`;
      }

      let finalNV3 = "00:00:00";
      if (
        state.monDigital.hrMsgEscaladaNV3 ||
        state.monDigital.minMsgEscaladaNV3
      ) {
        finalNV3 = `${pad(state.monDigital.hrMsgEscaladaNV3)}:${pad(state.monDigital.minMsgEscaladaNV3)}:00`;
      } else if (state.monDigital.timeMsgEscaladaNV3) {
        const partes = state.monDigital.timeMsgEscaladaNV3.split(":");
        finalNV3 = `${pad(partes[0])}:${pad(partes[1])}:00`;
      }

      const payloadDigitalTratado = {
        ...state.monDigital,
        timeMsgEscaladaNV2: finalNV2,
        timeMsgEscaladaNV3: finalNV3,
      };

      console.log("Payload Digital Tratado Enviado:", payloadDigitalTratado);

      if (entrada.ocupada) {
        dispatch(actionUpdateConfigPtMonDigital(payloadDigitalTratado));
        setTimeout(() => {
          if (updateConfigPtMonDigital.status === "success") {
            close();
          }
        }, 2000);
      } else {
        dispatch(actionPostConfigPtMonDigital(payloadDigitalTratado));
        setTimeout(() => {
          if (configPtMonDigital.status === "success") {
            close();
          }
        }, 2000);
      }
    } else if (tipoMon === "R") {
      if (entrada.ocupada) {
        dispatch(actionUpdateConfigPtMonMedidor(state.monMedidor));
        setTimeout(() => {
          if (updateConfigPtMonMedidor.status === "success") {
            close();
          }
        }, 2000);
      } else {
        dispatch(actionPostConfigPtMonMedidor(state.monMedidor));
        setTimeout(() => {
          if (configPtMonMedidor.status === "success") {
            close();
          }
        }, 2000);
      }
    }
  };
  const handlerChange = ({
    target: { value, name, checked, type },
  }: React.ChangeEvent<any | HTMLSelectElement>) => {
    console.log("handlerChange", value, name, checked, type, tipoMon);
    if (tipoMon === "A") {
      setState({
        ...state,
        monAnalogico: {
          ...state.monAnalogico,
          [name]: type === "checkbox" ? checked : value,
        },
        monDigital: {
          ...state.monDigital,
        },
        monMedidor: {
          ...state.monMedidor,
        },
      });
    } else if (tipoMon === "D") {
      setState({
        ...state,
        monAnalogico: {
          ...state.monAnalogico,
        },
        monDigital: {
          ...state.monDigital,
          [name]: type === "checkbox" ? checked : value,
        },
        monMedidor: {
          ...state.monMedidor,
        },
      });
    } else if (tipoMon === "R") {
      setState({
        ...state,
        monAnalogico: {
          ...state.monAnalogico,
        },
        monDigital: {
          ...state.monDigital,
        },
        monMedidor: {
          ...state.monMedidor,
          [name]: type === "checkbox" ? checked : value,
        },
      });
    }
  };

  const handleClose = () => {
    if (tipoMon === "A") {
      if (entrada.ocupada) {
        dispatch(actionResetStateUpdadePtMonAnalogico());
      }
      dispatch(actionResetGetConfigPtMonAnalogico());
      dispatch(actionResetStateConfigPtMonAnalogico());
      dispatch(actionResetDeleteConfigPtMonAnalogico());
    }
    if (tipoMon === "D") {
      if (entrada.ocupada) {
        dispatch(actionResetStateUpdadePtMonDigital());
      }
      dispatch(actionResetGetConfigPtMonDigital());
      dispatch(actionResetStateConfigPtMonDigital());
      dispatch(actionResetDeleteConfigPtMonDigital());
    }
    if (tipoMon === "R") {
      if (entrada.ocupada) {
        dispatch(actionResetStateUpdadePtMonMedidor());
      }
      dispatch(actionResetGetConfigPtMonMedidor());
      dispatch(actionResetStateConfigPtMonMedidor());
      dispatch(actionResetDeleteConfigPtMonMedidor());
    }
    if (
      configPtMonDigital.status === "success" ||
      configPtMonAnalogico.status === "success" ||
      configPtMonMedidor.status === "success" ||
      updateConfigPtMonDigital.status === "success" ||
      updateConfigPtMonAnalogico.status === "success" ||
      updateConfigPtMonMedidor.status === "success" ||
      deletePtMonAnalogico.status === "success" ||
      deletePtMonDigital.status === "success" ||
      deletePtMonMedidor.status === "success"
    ) {
      dispatch(actionGetModuloByCentral(centralSelected?.id));
    }
    close();
  };

  const refreshEntrada = () => {
    if (
      deletePtMonAnalogico.status === "success" ||
      deletePtMonDigital.status === "success" ||
      deletePtMonMedidor.status === "success"
    ) {
      handleClose();
    }
  };

  const deleleteConfig = () => {
    if (tipoMon === "A") {
      dispatch(actionDeleteConfigPtMonAnalogico());
    } else if (tipoMon === "D") {
      dispatch(actionDeleteConfigPtMonDigital());
    } else if (tipoMon === "R") {
      dispatch(actionDeleteConfigPtMonMedidor());
    }
  };

  React.useEffect(() => {
    if (getPtMonDigital.data) {
      setState({
        ...state,
        monDigital: {
          ...getPtMonDigital.data,
        },
      });
    }
  }, [getPtMonDigital.data]);

  React.useEffect(() => {
    if (getPtMonAnalogico.data) {
      setState({
        ...state,
        monAnalogico: {
          ...getPtMonAnalogico.data,
        },
      });
    }
  }, [getPtMonAnalogico.data]);

  React.useEffect(() => {
    if (getPtMonMedidor.data) {
      setState({
        ...state,
        monMedidor: {
          ...getPtMonMedidor.data,
        },
      });
    }
  }, [getPtMonMedidor.data]);

  React.useEffect(refreshEntrada, [
    deletePtMonDigital.status,
    deletePtMonAnalogico.status,
    deletePtMonMedidor.status,
  ]);

  return (
    <Modal
      header={<HeaderModal />}
      actions={
        <ActionsModal
          callbackDeleteConfig={entrada.ocupada ? deleleteConfig : null}
          callbackCancel={handleClose}
          callbackConfirm={sendConfiguration}
          loading={loading}
        />
      }
    >
      {tipoMon === "D" && (
        <FormMonDigital
          handlerChange={handlerChange}
          filledStore={state.monDigital}
        />
      )}

      {tipoMon === "A" && (
        <FormMonAnalogico
          handlerChange={handlerChange}
          filledStore={state.monAnalogico}
        />
      )}

      {tipoMon === "R" && (
        <FormMonMedidor
          handlerChange={handlerChange}
          filledStore={state.monMedidor}
        />
      )}
    </Modal>
  );
};

export default RegisterPontoMonitora;
